import { Navigate } from "react-router-dom";
import Header from "../header/header";
import Sidebar from "../sidebar/sidebar";
import Footer from "../footer/footer";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  const onLogout = () => {
    localStorage.removeItem("isLoggedIn");
    window.location.href = "/signin";
  };

  if (!isLoggedIn) {
    return <Navigate to="/signin" replace />;
  }
  return (
    <>
      <Header onLogout={onLogout} />
      <Sidebar onLogout={onLogout} />
      {children}
      <Footer />
    </>
  );
};
export default ProtectedRoute;
